
/**
 * Feedback Drawer JS
 * ─────────────────────────────────────────────────────────────────
 * Handles survey step navigation, progress updates, and submission.
 * ─────────────────────────────────────────────────────────────────
 */

(function () {
    const DRAWER_ID = 'feedback-drawer';
    const OVERLAY_ID = 'feedback-drawer-overlay';
    const CLOSE_ID = 'feedback-drawer-close';
    const PREV_ID = 'feedback-drawer-prev';
    const NEXT_ID = 'feedback-drawer-next';
    const SUBMIT_ID = 'feedback-drawer-submit';
    const PROGRESS_FILL_ID = 'feedback-progress-fill';
    const PROGRESS_TEXT_ID = 'feedback-progress-text';
    let currentStep = 1;
    let TOTAL_STEPS = 0;
    let responses = {};

    function initFeedback() {
        const drawer = document.getElementById(DRAWER_ID);
        if (!drawer) return;

        TOTAL_STEPS = parseInt(drawer.dataset.totalSteps || '1');
        const overlay = document.getElementById(OVERLAY_ID);
        const closeBtn = document.getElementById(CLOSE_ID);
        const prevBtn = document.getElementById(PREV_ID);
        const nextBtn = document.getElementById(NEXT_ID);
        const submitBtn = document.getElementById(SUBMIT_ID);

        if (!drawer) return;

        // Open drawer on trigger click
        document.addEventListener('click', (e) => {
            const trigger = e.target.closest('[data-feedback-trigger]');
            if (trigger) {
                e.preventDefault();
                openDrawer();
            }
        });

        // Close logic
        closeBtn.addEventListener('click', closeDrawer);
        overlay.addEventListener('click', closeDrawer);
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
                closeDrawer();
            }
        });

        // Navigation
        prevBtn.addEventListener('click', () => changeStep(-1));
        nextBtn.addEventListener('click', () => changeStep(1));

        // Emoji selection
        const satisfactionBtns = drawer.querySelectorAll('.feedback-drawer__satisfaction-btn');
        satisfactionBtns.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                const step = btn.closest('[data-step]').dataset.step;
                const value = btn.dataset.value;
                
                // Clear sibling selection
                btn.parentElement.querySelectorAll('.feedback-drawer__satisfaction-btn').forEach(b => b.classList.remove('is-selected'));
                btn.classList.add('is-selected');

                responses[step] = value;
                updateSubmitState();
            });
        });

        // Submit
        submitBtn.addEventListener('click', (e) => {
            if (currentStep === TOTAL_STEPS) {
              e.preventDefault();
              submitFeedback();
            }
        });
    }

    function openDrawer() {
        const drawer = document.getElementById(DRAWER_ID);
        if (drawer) {
          drawer.classList.add('is-open');
          document.body.style.overflow = 'hidden';
          updateProgress();
        }
    }

    function closeDrawer() {
        const drawer = document.getElementById(DRAWER_ID);
        if (drawer) {
          drawer.classList.remove('is-open');
          document.body.style.overflow = '';
        }
    }

    function changeStep(delta) {
        const nextStep = currentStep + delta;
        if (nextStep < 1 || nextStep > TOTAL_STEPS) return;

        // Hide current
        const currentEl = document.querySelector(`[data-step="${currentStep}"]`);
        if (currentEl) currentEl.classList.remove('is-active');

        // Show next
        currentStep = nextStep;
        const nextEl = document.querySelector(`[data-step="${currentStep}"]`);
        if (nextEl) nextEl.classList.add('is-active');

        updateProgress();
        updateNavButtons();
    }

    function updateProgress() {
        const fill = document.getElementById(PROGRESS_FILL_ID);
        const text = document.getElementById(PROGRESS_TEXT_ID);
        if (fill) fill.style.width = `${(currentStep / TOTAL_STEPS) * 100}%`;
        if (text) text.textContent = `${currentStep} of ${TOTAL_STEPS}`;
    }

    function updateNavButtons() {
        const prevBtn = document.getElementById(PREV_ID);
        const nextBtn = document.getElementById(NEXT_ID);
        const submitBtn = document.getElementById(SUBMIT_ID);

        prevBtn.disabled = currentStep === 1;
        
        if (currentStep === TOTAL_STEPS) {
          // nextBtn.style.display = 'none';
          // submitBtn.style.display = 'flex';
          updateSubmitState();
        } else {
          // nextBtn.style.display = 'flex';
          // submitBtn.style.display = 'none';
        }
    }

    function updateSubmitState() {
        const submitBtn = document.getElementById(SUBMIT_ID);
        if (!submitBtn) return;
        
        // Let's assume we can submit if at least current step has a response, or if on last step
        if (responses[currentStep]) {
          submitBtn.disabled = false;
          submitBtn.classList.add('can-submit');
        } else {
            // If on last step and no response, it's disabled.
            // For now, let's just make it always clickable if we want "Next" and "Submit" to be the same button?
            // User requested Previous, Next and Submit separately.
        }
    }

    function submitFeedback() {
        const content = document.querySelector('.feedback-drawer__content');
        content.innerHTML = `
            <div class="feedback-drawer__step is-active" style="text-align: center; display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100%;">
                <div style="font-size: 3rem; margin-bottom: 16px;">✨</div>
                <h2 class="feedback-drawer__heading">Thank you!</h2>
                <p class="feedback-drawer__subheading">Your feedback helps us provide a better experience for everyone.</p>
                <button class="feedback-drawer__btn feedback-drawer__btn--submit can-submit" onclick="document.getElementById('feedback-drawer').classList.remove('is-open'); document.body.style.overflow = '';">Close</button>
            </div>
        `;
        document.querySelector('.feedback-drawer__footer').style.display = 'none';
        document.querySelector('.feedback-drawer__progress-container').style.opacity = '0';
    }

    document.addEventListener('DOMContentLoaded', initFeedback);
    // Support for Shopify theme editor
    document.addEventListener('shopify:section:load', initFeedback);
})();
